export const chartData = {
  labels: [],
  datasets: [
    {
      label: 'Data 1',
      backgroundColor: ['#2F9936', '#29855E', '#257275', '#2C5A7D',
        '#314B82', '#383A88', '#473486', '#533184',
        '#622D82', '#7E277E', '#8D2B78', '#9C306D', '#AB355D', '#C13C3F', '#C2623C',
        '#C2783C', '#C2893C', '#C2963C', '#C2A13C', '#C2AC3C', '#C2B63C',
        '#C2C13C', '#A5BC3A', '#8CB538', '#6CAD36', '#369D31', '#29845F'],
      data: []
    }
  ]
}

export const chartOptions = {
  legend: {
    display: false
  },
  startAngle: -3.14 / 2.4
}
